
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";

    import DatePicker from "@/vue/components/DatePicker.vue";
    import PrintTextBox from "@/vue/components/PrintForm/PrintTextBox.vue";
    import PrintTextArea from "@/vue/components/PrintForm/PrintTextArea.vue";
    import PrintCheckbox from "@/vue/components/PrintForm/PrintCheckbox.vue";
    import PrintDatePicker from "@/vue/components/PrintForm/PrintDatePicker.vue";
    import PrintDateTimePicker from "@/vue/components/PrintForm/PrintDateTimePicker.vue";
    import PrintSelect from "@/vue/components/PrintForm/PrintSelect.vue";

    import { WorkPermitPerson } from "@/model/workPermits/WorkPermitPerson";

    @Component({
        components: {
            DatePicker,
            PrintDatePicker,
            PrintDateTimePicker,
            PrintTextBox,
            PrintTextArea,
            PrintCheckbox,
            PrintSelect
        }
    })
    export default class SouthEasternPerson extends Vue {

        @Prop({ required: true }) person!: WorkPermitPerson;
        @Prop({ default: false }) isReadOnly!: boolean;
        @Prop({ default: true }) canChangeIsMain!: boolean;

        //tickedImageUrl = require("@/images/print-check-box-ticked.svg");
        //untickedImageUrl = require("@/images/print-check-box-un-ticked.svg");

        selectMainPerson(person: WorkPermitPerson) {
            this.$emit("select-main-person", person);
        }

        get isMainContact(): boolean {
            return this.person.isMain;
        }
        set isMainContact(value: boolean) {
            //if (value) this.person.isMain = true;
            if (value) this.$emit("select-main-person", this.person);
        }
    }

